"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var R = _interopRequireWildcard(require("ramda"));
var _config = require("@trs/config");
var _icon = _interopRequireDefault(require("../icon"));
var _input = require("../input");
var _button = require("../button");
var _helpers = require("./helpers");
var _StyledTemplatePopup = require("./StyledTemplatePopup.style");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var MediaCreator = /*#__PURE__*/function (_Component) {
  _inherits(MediaCreator, _Component);
  var _super = _createSuper(MediaCreator);
  function MediaCreator(props) {
    var _this;
    _classCallCheck(this, MediaCreator);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "handleMediaTypeChange", function (type) {
      return _this.setState({
        type: type,
        src: '',
        errors: {}
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleMediaUrl", function (e) {
      _this.setState({
        src: e.target.value
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleMediaAltText", function (e) {
      return _this.setState({
        alt: e.target.value
      });
    });
    _defineProperty(_assertThisInitialized(_this), "validateData", function () {
      var _this$state = _this.state,
        src = _this$state.src,
        alt = _this$state.alt,
        type = _this$state.type;
      var videoPlatformAccepted = _this.props.videoPlatformAccepted;
      var isVideoPlatform = function isVideoPlatform(video) {
        return videoPlatformAccepted.find(function (platform) {
          return video.includes(platform);
        });
      };
      var urlError = {
        length: src.length > _helpers.MAX_TEXT_LENGTH.URL ? "URL should have a maximum of ".concat(_helpers.MAX_TEXT_LENGTH.URL, " characters.") : null,
        validity: !(0, _helpers.isValidURL)(src) || (0, _helpers.isNotAllowedUrl)(src) || type === _config.MEDIA_TYPE.VIDEO && !isVideoPlatform(src) ? 'Invalid URL' : null
      };
      var altTextError = {
        length: alt.length > _helpers.MAX_TEXT_LENGTH.ALT ? "Text should have a maximum of ".concat(_helpers.MAX_TEXT_LENGTH.ALT, " characters.") : null
      };
      var validUrl = R.isNil(urlError.length) && R.isNil(urlError.validity) && R.isNil(altTextError.length);
      if (R.isEmpty(src)) {
        _this.setState({
          errors: {}
        });
      } else if (!validUrl) {
        _this.setState({
          errors: {
            src: validUrl ? '' : urlError.length || urlError.validity,
            alt: validUrl ? '' : altTextError.length
          }
        });
      }
      return validUrl;
    });
    _defineProperty(_assertThisInitialized(_this), "onSave", function () {
      var _this$state2 = _this.state,
        type = _this$state2.type,
        src = _this$state2.src,
        alt = _this$state2.alt;
      var isDataValid = _this.validateData();
      if (isDataValid) {
        _this.props.onChange({
          type: type,
          src: src,
          alt: alt
        });
        _this.props.onClose();
      }
    });
    _this.state = {
      type: props.type,
      src: props.src,
      alt: props.alt,
      errors: {}
    };
    return _this;
  }
  _createClass(MediaCreator, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        onClose = _this$props.onClose,
        componentName = _this$props.componentName,
        labels = _this$props.labels,
        recommendedMediaSizes = _this$props.recommendedMediaSizes,
        supportedMediaTypes = _this$props.supportedMediaTypes;
      var _this$state3 = this.state,
        type = _this$state3.type,
        src = _this$state3.src,
        alt = _this$state3.alt,
        errors = _this$state3.errors;
      var recommendedSizes = R.isEmpty(recommendedMediaSizes) ? _helpers.RECOMMENDED_SIZE : recommendedMediaSizes;
      return /*#__PURE__*/_react["default"].createElement(_StyledTemplatePopup.StyledMediaCreator, null, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        id: "media-creator-close",
        icon: "ion-close-circled",
        size: 18,
        className: "input-clear-icon",
        "aria-label": "Close pop-up",
        onClick: onClose
      }), /*#__PURE__*/_react["default"].createElement("p", {
        className: "popup-title"
      }, labels.EMBED_LINK), /*#__PURE__*/_react["default"].createElement(_StyledTemplatePopup.Tabs, null, Object.keys(supportedMediaTypes).map(function (mediaType) {
        return /*#__PURE__*/_react["default"].createElement(_StyledTemplatePopup.Tab, {
          key: supportedMediaTypes[mediaType],
          className: (0, _classnames["default"])({
            active: supportedMediaTypes[mediaType] === type
          }),
          onClick: function onClick() {
            return _this2.handleMediaTypeChange(supportedMediaTypes[mediaType]);
          }
        }, /*#__PURE__*/_react["default"].createElement("p", null, supportedMediaTypes[mediaType]));
      })), /*#__PURE__*/_react["default"].createElement(_input.InputV2, {
        type: "text",
        placeholder: labels.ENTER_LINK_HERE,
        error: R.prop('src', errors),
        id: "media-url-input",
        value: src,
        onChange: this.handleMediaUrl,
        onFocus: this.validateData
      }), /*#__PURE__*/_react["default"].createElement("p", {
        className: "helpertext"
      }, type === _config.MEDIA_TYPE.IMAGE && "".concat(labels.IMAGE_RECOMMENDED_SIZE, ": ").concat(recommendedSizes[componentName].width, " x ").concat(recommendedSizes[componentName].height, " px")), /*#__PURE__*/_react["default"].createElement("p", {
        className: "popup-title"
      }, type === _config.MEDIA_TYPE.IMAGE ? labels.MEDIA_IMAGE_ALT_TEXT : labels.MEDIA_VIDEO_TITLE), /*#__PURE__*/_react["default"].createElement(_input.InputV2, {
        type: "text",
        placeholder: labels.ENTER_TEXT_HERE,
        error: R.prop('alt', errors),
        id: "media-alt-text-input",
        value: alt,
        onChange: this.handleMediaAltText
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "footer"
      }, /*#__PURE__*/_react["default"].createElement(_button.Button, {
        type: "naked",
        medium: true,
        action: onClose,
        className: "media-creator-cancel"
      }, labels.CANCEL_MEDIA_LINK), /*#__PURE__*/_react["default"].createElement(_button.Button, {
        type: "primary",
        medium: true,
        action: this.onSave,
        className: "media-creator-save",
        disabled: R.isEmpty(src)
      }, labels.ADD_MEDIA_LINK)));
    }
  }]);
  return MediaCreator;
}(_react.Component);
MediaCreator.defaultProps = {
  type: _config.MEDIA_TYPE.IMAGE,
  src: '',
  alt: '',
  componentName: _helpers.MEDIA_COMPONENTS.MEDIA,
  recommendedMediaSizes: {},
  videoPlatformAccepted: [],
  supportedMediaTypes: _config.MEDIA_TYPE
};
MediaCreator.propTypes = {
  onClose: _propTypes["default"].func.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  type: _propTypes["default"].string,
  src: _propTypes["default"].string,
  alt: _propTypes["default"].string,
  componentName: _propTypes["default"].string,
  supportedMediaTypes: _propTypes["default"].shape({}),
  labels: _propTypes["default"].shape({
    EMBED_LINK: _propTypes["default"].string,
    ADD_MEDIA_LINK: _propTypes["default"].string,
    CANCEL_MEDIA_LINK: _propTypes["default"].string,
    ENTER_TEXT_HERE: _propTypes["default"].string,
    MEDIA_IMAGE_ALT_TEXT: _propTypes["default"].string,
    MEDIA_VIDEO_TITLE: _propTypes["default"].string,
    IMAGE_RECOMMENDED_SIZE: _propTypes["default"].string,
    ENTER_LINK_HERE: _propTypes["default"].string
  }).isRequired,
  recommendedMediaSizes: _propTypes["default"].shape({}),
  videoPlatformAccepted: _propTypes["default"].arrayOf(_propTypes["default"].string)
};
MediaCreator.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "handleMediaTypeChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "type",
      "type": null
    }],
    "returns": null
  }, {
    "name": "handleMediaUrl",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "handleMediaAltText",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "validateData",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onSave",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "MediaCreator",
  "props": {
    "type": {
      "defaultValue": {
        "value": "MEDIA_TYPE.IMAGE",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "src": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "alt": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "componentName": {
      "defaultValue": {
        "value": "MEDIA_COMPONENTS.MEDIA",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "recommendedMediaSizes": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "videoPlatformAccepted": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "string"
        }
      },
      "required": false
    },
    "supportedMediaTypes": {
      "defaultValue": {
        "value": "MEDIA_TYPE",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "onClose": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "onChange": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "labels": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "EMBED_LINK": {
            "name": "string",
            "required": false
          },
          "ADD_MEDIA_LINK": {
            "name": "string",
            "required": false
          },
          "CANCEL_MEDIA_LINK": {
            "name": "string",
            "required": false
          },
          "ENTER_TEXT_HERE": {
            "name": "string",
            "required": false
          },
          "MEDIA_IMAGE_ALT_TEXT": {
            "name": "string",
            "required": false
          },
          "MEDIA_VIDEO_TITLE": {
            "name": "string",
            "required": false
          },
          "IMAGE_RECOMMENDED_SIZE": {
            "name": "string",
            "required": false
          },
          "ENTER_LINK_HERE": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": true
    }
  }
};
var _default = MediaCreator;
exports["default"] = _default;